import { Classroom } from "@/types/models/Classroom.interface";

/**
 * Transforms a list of classrooms into a simplified format suitable for sidebar display
 *
 * @param classrooms - Array of classroom objects containing detailed classroom information
 * @returns Array of simplified classroom objects containing only name and ID
 * @example
 * const classrooms = [{ name: "Math 101", unique_id: "123", ... }];
 * const sidebarList = getClassroomsSidebarList(classrooms);
 * // Returns: [{ name: "Math 101", id: "123" }]
 */
const getClassroomsSidebarList = (classrooms: Classroom[]) => {
  return classrooms.map((classroom) => {
    return {
      name: classroom.name,
      id: classroom.unique_id,
    };
  });
};

export default getClassroomsSidebarList;
